/**
 * Class GameItemModelCache
 * @param $gameID {String} the id of the game the data is from
 * @param $timestamp {Number} the time of creation
 *
 * a template for a game model with all the data sources created,
 * waiting to be filled with delicious data
 */
define('GameDayCore/GDModel/storage/GameItemModelCache',['require','exports','module'],function(require,exports,module) {

    function GameItemModelCache($gameID, $timestamp) {
        this.gameID = $gameID,
        this.timestamp = $timestamp;
    }

    GameItemModelCache.prototype = {
        gameID: undefined,
        timestamp: undefined,
        play: undefined,
        players: undefined,
        game: undefined,
        boxscore: undefined,
        bench: undefined,
        linescore: undefined,
        lineup: undefined,
        scores: undefined,
        hitchart: undefined,
        miniscoreboard: undefined,
        inning: undefined,
        all_innings:undefined,
        playercard: undefined,
        hotcoldzone: undefined,
        displayconfig: undefined,
        jingles: undefined,
        tpl_lib: undefined,
        video: undefined,
        liveLookin: undefined,
        gdConfig: undefined,
        skin_config: undefined,
        timecode: undefined,
        staticresources: undefined,
        moundball: undefined
    };

    return GameItemModelCache;
});
